export default "__VITE_ASSET__CfE8eND3__"